'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _certificatesFilter = require('./certificates-filter.html');

var _certificatesFilter2 = _interopRequireDefault(_certificatesFilter);

var _certificatesFilter3 = require('./certificates-filter.controller');

var _certificatesFilter4 = _interopRequireDefault(_certificatesFilter3);

require('./certificates-filter.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var certificatesFilterComponent = {
  restrict: 'E',
  bindings: {
    applyFilters: '&'
  },
  template: _certificatesFilter2.default,
  controller: _certificatesFilter4.default,
  controllerAs: 'vm'
};

exports.default = certificatesFilterComponent;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/certificates-filter/certificates-filter.component.js
 **/